import React, { useState, useEffect } from 'react'
import { View, Image, Text, TouchableOpacity, StyleSheet, Alert, PixelRatio, Platform } from 'react-native'
import { Ionicons, Feather } from '@expo/vector-icons'
import theme from '../../../theme'
import { useBottomSheet } from '../customUtils/context/BottomSheetContext'
import EditProfileScreen from './EditProfileScreen'
import styles from './ProfileHeaderStyles'
import { placeholderGeneral } from '../customUtils/Constants'
import { avatarPlaceholder, getAvatarPlaceholderLocal } from '../customUtils/Constants'
import { safeImageSource } from '../../utils/imageUtils'
import { getAppVersion } from '../customUtils/AppConstants'
import { CONFIG_IP_TEST, TEST, apiUrl } from '../../config/config'
import { getLanguage } from '../appBar/context/LocalizationContext'
import * as ImagePicker from 'expo-image-picker'
// import { fetchAuthSession } from 'aws-amplify/auth'
import { getCurrentUser } from 'aws-amplify/auth'
import { getAuthToken } from '../../utils/functions.utils'
import { uploadData } from 'aws-amplify/storage'
import { manipulateAsync, FlipType, SaveFormat } from 'expo-image-manipulator'
import { getImageStogeUrl } from '../imageUploader/ImageStorage'
import { addUser, openDB, updateGlobalVersion, deleteAllTables, deleteAllTablesContent, deleteDB } from '../../db/indexDB'
import NetInfo from '@react-native-community/netinfo'
import { isEntornoTesting } from '../../utils/functions.utils'

export default function ProfileHeader({ avatar, fullName, user, version, onClickEdit, activeButtonDeleted, onClickDelete, onClickChangePassword }) {
    const { openBottomSheet } = useBottomSheet()
    const [user_data, setUser] = useState(user)
    const { languageFile } = getLanguage()
    const [photoURL, setPhotoURL] = useState(avatar)
    const [selectedImage, setSelectedImage] = useState(null)
    const [languages, setLanguages] = useState(user_data?.languages ?? [])
    useEffect(() => {
        setPhotoURL(avatar)
    }, [avatar])
    const fontScale = 1
    const iconSize = 24 * fontScale

    useEffect(() => {
        if (user) {
            const updatedUser = { ...user, avatar: avatar }
            setUser(updatedUser)
        }
    }, [user])

    const onSaveEditProfile = (new_data) => {
        console.log('🚀 ~ llegaaa ~ new_data:', new_data)
        if (new_data) {
            setUser(new_data)
        }
        openBottomSheet(null) // Cierra el modal al guardar los cambios
    }

    const handle_edit_profile = () => {
        console.log('handle_edit_profile')
        if (!user_data) {
            return
        }
        const snapPoints = ['80%']
        openBottomSheet(
            <EditProfileScreen
                user_data={user_data}
                avatar={user_data?.avatar}
                onSave={onSaveEditProfile}
                activeButtonDeleted={activeButtonDeleted}
                onClickDelete={onClickDelete}
            />,
            snapPoints,
        )
    }

    const editPhoto = async () => {
        //revisar esto por problemas con los mensajes que tiene IOS para hacer el ipa //
        const cameraPermissionResult = await ImagePicker.requestCameraPermissionsAsync()
        const mediaLibraryPermissionResult = await ImagePicker.requestMediaLibraryPermissionsAsync()

        if (cameraPermissionResult.granted === false || mediaLibraryPermissionResult.granted === false) {
            Alert.alert(languageFile.insufficient_permissions, languageFile.permissions_to_access)
            return
        }

        const options = {
            allowsEditing: true,
            aspect: [1, 1],
            quality: 0.3, //1, // la calidad 1 es la mas alta disponible, si  se quiere una calidad baja se puede poner un numero entre 0 y 1, ej, 0.5 y reduce la calidad a la mitad
        }

        Alert.alert(
            languageFile.choose_font,
            languageFile.select_the_image,
            [
                {
                    text: languageFile.camera,
                    onPress: async () => {
                        const pickerResult = await ImagePicker.launchCameraAsync(options)
                        handleImagePickerResult(pickerResult)
                    },
                },
                {
                    text: languageFile.gallery,
                    onPress: async () => {
                        const pickerResult = await ImagePicker.launchImageLibraryAsync(options)
                        handleImagePickerResult(pickerResult)
                    },
                },
            ],
            { cancelable: true },
        )
    }

    const handleImagePickerResult = async (pickerResult) => {
        console.log('🚀 ~ editPhoto ~ pickerResult:', pickerResult)

        if (!pickerResult.cancelled) {
            try {
                const response = await fetch(pickerResult.uri)
                const blob = await response.blob()
                const timestamp = Date.now()
                const filename = `avatars/profile-${user_data._id}-${timestamp}.jpg`
                const thumbnailFilename = `avatars/profile-thumbnail-${user_data._id}-${timestamp}.jpg`
                let sube = await uploadData({
                    key: filename,
                    data: blob,
                    options: {
                        contentType: 'image/jpeg',
                    },
                }).result

                const imageUrl = await getImageStogeUrl(filename)
                setPhotoURL(imageUrl)
                setSelectedImage({ avatar: filename, thumbnail: thumbnailFilename })

                // Crear una versión miniatura de la imagen con menor calidad y resolución
                const thumbnailOptions = {
                    compress: 0.5, // Comprimir la imagen a la mitad
                    format: 'jpeg', // Formato JPEG
                    base64: false, // No devolver en base64
                    width: 100, // Ancho de la imagen
                    height: 100, // Alto de la imagen
                }
                const thumbnailResult = await manipulateAsync(pickerResult.uri, [{ resize: thumbnailOptions }], {
                    compress: 0.5,
                    format: 'jpeg',
                    base64: false,
                })

                const thumbnailResponse = await fetch(thumbnailResult.uri)
                const thumbnailBlob = await thumbnailResponse.blob()
                const thumbnailSube = await uploadData({
                    key: thumbnailFilename,
                    data: thumbnailBlob,
                    options: {
                        contentType: 'image/jpeg',
                    },
                }).result
                const thumbnailImageUrl = await getImageStogeUrl(thumbnailFilename)
                // Editar perfil
                await updateProfile(filename, thumbnailFilename)

                // console.log('🚀 ~ thumbnailImageUrl:', thumbnailImageUrl)
            } catch (error) {
                console.error('Error al subir la imagen:', error)
            }
        }
    }
    const updateProfile = async (avatarImage, avatarThumbnail) => {
        try {
            let data
            const authToken = await getAuthToken()
            if (!authToken) return
            const user = await getCurrentUser()
            const database = await openDB()
            let editedData = {}

            const netInfoState = await NetInfo.fetch()
            if (netInfoState.isConnected) {
                editedData = {
                    avatar_image: avatarImage,
                    avatar_image_thumbnail: avatarThumbnail,
                }

                const response = await fetch(`${apiUrl}/edit_user_profile`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: authToken,
                    },
                    body: JSON.stringify({
                        user_data: editedData,
                    }),
                })

                if (!response.ok) {
                    throw new Error('Fallo al obtener el usuario')
                }

                data = await response.json()
                console.log('🚀 ~ update users:', data)
            } else {
                console.log('sin conexion')
                data = {
                    status: 0,
                }
            }

            if (data?.status === 1) {
                try {
                    await deleteAllTablesContent()
                    await openDB(true)
                    const user_data = {
                        ...data.single.user_data,
                        delete_active: data.single.delete_active,
                        languages: languages,
                        login: true,
                        cognito_id: session.idToken.payload.sub,
                    }
                    await addUser(database, user_data)
                } catch (error) {
                    console.error('Error al agregar usuario:', error)
                }
                let version_update = data.single.user_data.data_version ? data.single.user_data.data_version : 0
                await updateGlobalVersion(database, 'user', version_update)
                console.log('Datos guardados localmente')
                data.single.user_data.avatar = photoURL
                let dataSave = data.single.user_data
                dataSave.languages = languages
                dataSave.delete_active = data.single.delete_active ?? false
                setUser(dataSave)
            }
        } catch (error) {
            console.error('Error al obtener el usuario autenticado:', error)
        }
    }

    const isEntornoTest = isEntornoTesting()

    return (
        <View style={styles.container}>
            <TouchableOpacity style={[styles.containerAvatar]} onPress={() => editPhoto()}>
                <Image
                    style={[styles.avatar, { resizeMode: 'cover' }]}
                    source={safeImageSource(photoURL, Platform.OS === 'web' ? avatarPlaceholder : getAvatarPlaceholderLocal())}
                />
                <View style={styles.containerIcon}>
                    <Ionicons name='add-circle' size={iconSize} color={theme.colors.colorPrimary} style={styles.icon} />
                </View>
            </TouchableOpacity>

            <View style={styles.dataBlock}>
                <Text style={styles.name}>
                    {user_data?.name}
                    {user_data?.last_name}
                </Text>
                <Text style={styles.user}>{user_data?.email && user_data?.email != 'a@a.com' ? user_data?.email : ''}</Text>
                {user_data?.nickname && user_data?.nickname !== '' && <Text style={styles.user}>{user_data?.nickname}</Text>}

                <TouchableOpacity
                    onPress={() => {
                        onClickChangePassword()
                    }}
                >
                    <Text
                        style={[
                            {
                                color: theme.colors.colorPrimary,
                                fontWeight: 'bold',
                                marginTop: 5,
                                fontSize: 13,
                            },
                        ]}
                    >
                        {'Cambiar contraseña'}
                    </Text>
                </TouchableOpacity>
                {isEntornoTest && <Text style={styles.version}>{'Entorno Test'}</Text>}
            </View>

            {/* <TouchableOpacity onPress={() => handle_edit_profile()} style={styles.editIcon}>
                <Feather name='edit-2' size={18} color={theme.colors.colorPrimary} />
            </TouchableOpacity> */}
        </View>
    )
}
